<template>
  <div class="search-box">
    <!-- 英文 -->
    <input
        v-if="CookiesOne === 'en-US'"
        ref="input"
        type="text"
        placeholder="Pls input key words"
        @keyup.enter="onSumbit"
    />
    <!-- 中文 -->
    <input
        v-if="CookiesOne !== 'en-US'"
        ref="input"
        type="text"
        placeholder="请输入关键词"
        @keyup.enter="onSumbit"
    />
    <span class="search-btn" @click="onSumbit">
      <i class="search-icon">{{ TLang("搜索", "my") }}</i>
    </span>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "SearchBox",
  data() {
    return {
      CookiesOne: Cookies.get("df_lang")
    }
  },
  methods: {
    onSumbit() {
      const value = this.$refs.input.value.trim();
      this.$emit('search', value)
    }
  }
}
</script>

<style lang="less" scoped>
.search-box {
  height: 40px;
  width: 480px;
  display: flex;
  align-items: stretch;
  input {
    flex: 1 1 0px;
    height: auto;
    border: 1px solid #CCCCCC;
    &::-webkit-input-placeholder {
      color: #999;
    }
    &::-moz-input-placeholder {
      color: #999;
    }
    &:-ms-input-placeholder {
      color: #999;
    }
  }
  .search-btn {
    width: 40px;
    height: auto;
    background: #065293;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .search-icon {
    display: inline-block;
    vertical-align: middle;
    background: url("../imgs/icon_search_white.png") no-repeat;
    width: 20px;
    height: 20px;
    background-size: cover;
    text-indent: -9999px;
  }
}
</style>
